import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";

const image1 = "./mock-assets/images/website/contact-tile1.jpg";
const image2 = "./mock-assets/images/website/contact-tile2.jpg";

export default {
    title: "Components/Nimbus Contact Tile",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-nb-contact-tile",
    args: {
        image: image1,
        link: "https://example.com",
        linkLabel: "Termin anfragen",
        wide: false,
    },
    argTypes: {
        image: {
            control: "text",
            description: "path to the image used as the tile background",
        },
        link: {
            control: "text",
            description: "the URL of the link",
        },
        linkLabel: {
            control: "text",
            description: "the label of the link",
        },
        wide: {
            control: "boolean",
            description: "use wide layout",
        },
    },
};

const Template = ({ image, link, linkLabel, wide }) => {
    return html`
        <ux-iws-nb-contact-tile-group>
            <ux-iws-nb-contact-tile image="${image}" ?wide=${wide}>
                <h2 slot="title">
                    <strong>Maßschneiderung</strong>
                    <br />
                    vor Ort
                </h2>
                <div slot="copy">${getDummyText(140)}</div>
                <a slot="link" href="${link}">${linkLabel}</a>
            </ux-iws-nb-contact-tile>
        </ux-iws-nb-contact-tile-group>
    `;
};

const GroupTemplate = ({ amount, differentLengths, headline, subheadline }) => {
    return html`
        <ux-iws-nb-contact-tile-group
            headline=${headline}
            subheadline=${subheadline}
        >
            ${Array.from({ length: amount }).map((_, i) => {
                const isWide = i === 2;
                return html`
                    <ux-iws-nb-contact-tile
                        image="${isWide ? image2 : image1}"
                        ?wide=${isWide}
                    >
                        <h2 slot="title">
                            <strong>Maßschneiderung</strong>
                            <br />
                            vor Ort
                        </h2>
                        <div slot="copy">
                            ${getDummyText(differentLengths && !i ? 444 : 140)}
                        </div>
                        <a slot="link" href="https://example.com">
                            Termin anfragen
                        </a>
                    </ux-iws-nb-contact-tile>
                `;
            })}
        </ux-iws-nb-contact-tile-group>
    `;
};

export const Default = Template.bind({});
Default.args = {};

export const Wide = Template.bind({});
Wide.args = {
    image: image2,
    wide: true,
};

export const Group = GroupTemplate.bind({});
Group.args = {
    amount: 3,
    headline: "Ihr TruFiber S maßgeschneidert auf ihre Bedürfnisse",
    subheadline:
        "Mit unserem einzigartigen Service und Know-how können wir jede Maschine ganz speziell auf ihre Applikation individualisieren",
};

export const GroupWithSingleHeadline = GroupTemplate.bind({});
GroupWithSingleHeadline.args = {
    amount: 3,
    headline: "Ihr TruFiber S maßgeschneidert auf ihre Bedürfnisse",
};

export const GroupWithDifferentLengths = GroupTemplate.bind({});
GroupWithDifferentLengths.args = {
    amount: 3,
    differentLengths: true,
};
